module.exports = __webpack_public_path__ + "img/license.0a6c4e01.png";